let debugging = false;
export function isDebug() {
    return debugging;
}
export default {
    computed: {
        isDebug() {
            const query = this.$route.query;
            if (!query || !query.debug) {
                debugging = false;
                return false;
            }
            const lowered = query.debug.toLowerCase();
            switch (lowered) {
                case 'true':
                case 'yes':
                case '1':
                    debugging = true;
                    return true;

                case 'false':
                case 'no':
                case '0':
                case null:
                    debugging = false;
                    return false;

                default:
                    debugging = Boolean(lowered);
                    return debugging;
            }
        },
    },
};
